<template>
  <!-- <div class="about-us-container"> -->
  <!-- 新增 footer 区块 -->
  <div class="footer-info">
    <!-- 左边 Logo -->
    <div class="footer-left">
      <img src="@/assets/homeInfor/图片3.png" alt="logo" class="footer-logo" />
    </div>

    <!-- 中间文字区域 -->
    <div class="footer-center">
      <div class="footer-text">
        © 2025 HONG KONG TWENTY-FIVE THOUSAND TECHNOLOGY LIMITED
      </div>
      <div class="footer-beian">
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="noopener noreferrer"
        >
          備案號：粵ICP備2025410853號
        </a>
      </div>
    </div>

    <!-- 右边二维码和下载链接 -->
    <div class="footer-right">
      <img src="@/assets/homeInfor/erweima.png" alt="二维码" class="qrcode" />
      <div class="download-links">
        <img src="@/assets/homeInfor/图片2.png" alt="" class="download" />
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
   name: "viewFooter",
  data() {
    return {
    };
  },
};
</script>

<style scoped>
.footer-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1200px; /* 最大宽度 */
  margin: 0 auto; /* 水平居中 */
  padding: 0 60px; /* 左右内边距，留白 */
  box-sizing: border-box; /* 让padding算在宽度里 */
  height: auto; /* 去掉固定高度 */
  line-height: normal; /* 行高自动 */
}
.footer-left .footer-right {
  flex: 1;
  margin: 10px;
  display: flex;
}
.footer-right {
  flex: 1;
  display: flex;
  align-items: center; /* ✅ 垂直方向对齐（顶部对齐或居中都可） */
  justify-content: center;
  /* gap: 20px; ✅ //二维码和下载图片之间的间距 */
}
.footer-center {
  flex: 2;
  /* margin: 10px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
}
.footer-logo {
  width: 150px;
  height: auto;
}
.footer-text {
  color: #ec693d;
  font-weight: bold;
  margin-bottom: 5px;
}
.footer-beian a {
  color: #ec693d;
  text-decoration: none;
}
.qrcode {
  width: 120px;
  height: 120px;
  display: block;
  margin-bottom: 10px;
}
.download {
  width: 130px;
  height: 100px;
  display: block;
  margin-bottom: 10px;
}
</style>
